/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const is_superuser = currentUser?.is_superuser;
  const permissions = currentUser?.permissions;
  return {
    can1: is_superuser || permissions?.includes(1),
    can2: is_superuser || permissions?.includes(2),
    can3: is_superuser || permissions?.includes(3),
    can7: is_superuser || permissions?.includes(7),
    can8: is_superuser || permissions?.includes(8),
    can9: is_superuser || permissions?.includes(9),
    can10: is_superuser || permissions?.includes(10),
    can11: is_superuser || permissions?.includes(11),
    can12: is_superuser || permissions?.includes(12),
    can13: is_superuser || permissions?.includes(13),
    can14: is_superuser || permissions?.includes(14),
    can15: is_superuser || permissions?.includes(15),
  };
}
